import React, { useCallback, useEffect, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { useAppDispatch } from "../../../../../application/store";
import { Color, ColorsRepository } from "../../../../../domain";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";
import { loadColors } from "../../../../../application/colors-slice";

type EditColorModalProps = {
  visible: boolean;
  onClose: () => void;
  color?: Color;
};

const EditColorModal: React.FC<EditColorModalProps> = ({
  visible,
  onClose,
  color,
}) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [colorCode, setColorCode] = useState<string>();

  const stbaleSetFeilds = useCallback(form.setFields, []);
  useEffect(() => {
    stbaleSetFeilds([
      { name: "title", value: color?.title },
      { name: "color", value: color?.color },
    ]);
    setColorCode(color?.color);
  }, [stbaleSetFeilds, color]);

  const submit = async () => {
    try {
      await form.validateFields();
      if (color === undefined) return;
      setIsLoading(true);
      const res = await ServiceLocater.get<ColorsRepository>(
        Services.ColorsRepository
      ).edit(color.id.toString(), {
        title: form.getFieldValue("title"),
        color: colorCode,
      });
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success("رنگ با موفقیت ایجاد شد");
          dispatch(loadColors());
          onClose();
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      title={"رنگ جدید"}
      visible={visible}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      onOk={submit}
      confirmLoading={isLoading}
      bodyStyle={{ paddingBottom: 0 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="نام رنگ"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input name="title" defaultValue={color?.title} />
        </Form.Item>
        <Form.Item
          name="color"
          label="رنگ"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input
            name="color"
            type="color"
            defaultValue={color?.color}
            onChange={(e) => setColorCode(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditColorModal;
